import { Component, Input, OnInit } from "@angular/core"
import { CHNode } from "../../models/node.model"
import { BrowsingService } from "../../services/browsing.service"
import { UserService } from "../../services/user.service"
import { STATIC_IMAGES } from "../../models/constants"

@Component({
    selector: "app-internal-server-error",
    templateUrl: "./internal-server-error.component.html",
    styleUrls: ["./internal-server-error.component.scss"],
})
export class InternalServerErrorComponent implements OnInit {
    public image: any

    @Input()
    public subjects: CHNode[]

    @Input()
    public errorMessage: string

    public isStudent: boolean
    constructor(private browsingService: BrowsingService, private userService: UserService) {
        this.image = STATIC_IMAGES.on_the_go
    }

    public ngOnInit() {
        this.isStudent = this.userService.hasStudentExperience()
    }
}
